import {Component, Prop, Vue} from 'vue-property-decorator';
import WorkItemList from './WorkItemList/WorkItemList.vue';
import WorkItemDetail from './WorkItemDetail/WorkItemDetail.vue';
import WorkItemBulkModal from './WorkItemBulkModal/WorkItemBulkModal.vue';

import { WorkItem } from '@/types';
@Component({
    components: {
        WorkItemList,
        WorkItemDetail,
        WorkItemBulkModal
    }
})
export default class WorkerItems extends Vue {
    private workItems: WorkItem[] = [];
    private bulkWorkItems: WorkItem[] = [];
    private baseUrl = '/work_items';
    private dialogVisible = false;
    private withHidden = false;
    private isLoading = true;
    private selectedWorkItem: WorkItem | null = {
        id: '',
        name: '',
        memo: '',
        is_hidden: false
    };

    @Prop()
    private id!: string

    private created() {
       this.getWorkItems(false);
    }

    private getWorkItems(withHidden: boolean) {
        this.isLoading = true;
        this.withHidden = withHidden;
        this.$apiClient.doRequest('get', `${this.baseUrl}?with_hidden=${withHidden}`).then((ret) => {
            this.workItems = ret.work_items;
            this.isLoading = false;

            if(this.id) {
                const selectedWorkItemById = this.workItems.find(workItem => {
                    return workItem.id === this.id
                }) || null

                if(selectedWorkItemById === null){
                    // 参照先作業項目が削除されている場合、作業項目トップへ遷移させる
                    this.$router.push(`/master/work_items/`, () => {return});
                    return
                }

                this.selectedWorkItem = selectedWorkItemById
            }
        });
    }
    private getBulkWorkItems() {
        this.isLoading = true;
        this.$apiClient.doRequest('get', `${this.baseUrl}?with_hidden=true`).then((ret) => {
            this.bulkWorkItems = ret.work_items;
            this.isLoading = false;
        });
    }

    private selectWorkItem(selectWorkItem: WorkItem) {
        this.selectedWorkItem = selectWorkItem;
    }

    private createWorkItem() {
        this.selectedWorkItem = {
            id: 'create',
            name: '',
            memo: '',
            is_hidden: false
        }
    }

    private  openModal() {
        this.getBulkWorkItems();
        this.dialogVisible = true;
    }

    private switchedDisplay(id: string) {
        this.getWorkItems(this.withHidden);
    }
}